export interface ICountry {
  id?: number;
  codeCountry?: string;
  name?: string;
  taxe?: boolean;
  longitude?: number;
  latitude?: number;
}

export class Country implements ICountry {
  codeCountry!: string;
  id!: number;
  name!: string;
  taxe?: boolean;
  longitude?: number;
  latitude?: number;
}
